import { ActionCertificatesClearCertificates } from '@app/certificates/manage/manage.reducer';
import { ActionSettingsClearSettings } from '@app/profile/settings/settings.reducer';
import { Injectable, Input, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Action, Store, createAction } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs/operators';
import {
  AuthActionTypes, ActionAuthLoginSuccess, ActionAuthLogout
} from './auth.reducer';
import { AuthenticationService } from '@app/core/auth/authentication.service';
import { ActionSettingsInitialize } from '@app/profile/settings/settings.reducer';
import { InfoService } from '@app/core/info/info.service';
import { ActionPacksInitialize } from '@app/certificates/packs/packs.reducer';

import { EmergencyService } from '@app/core/auth/component/emergency-login/emergency-login.service';
import { TranslateService } from '@ngx-translate/core';
import { SettingsService } from '@app/profile/settings/settings.service';
import { ActionHistoryClearHistory } from '@app/certificates/history/history.reducer';
import { ActionDevicesClearDevices } from '@app/certificates/devices/devices.reducer';
import { ActionProfilePlanClear } from '@app/profile/profile-remaining-count/profile-plan.actions';
import { ActionNomenclatureInitialize, ActionNomenclatureClear } from '../nomenclature/nomenclature.actions';

@Injectable()
export class AuthEffects {

  @Input() personalId: string;


  private actions$ = inject(Actions<Action>);
  private store = inject(Store<any>);
  private router = inject(Router)
  private service = inject(AuthenticationService)
  private info = inject(InfoService)
  private emergency = inject(EmergencyService)
  private translateService = inject(TranslateService)
  private settingsService = inject(SettingsService)


  loginSuccess$ = createEffect(() => (
    this.actions$
      .pipe(ofType<ActionAuthLoginSuccess>(AuthActionTypes.LOGIN_SUCCESS),
        tap((action: ActionAuthLoginSuccess) => {
          this.store.dispatch(new ActionSettingsInitialize({ settings: action.payload.auth.settings }));
          this.store.dispatch(new ActionPacksInitialize({ items: action.payload.auth.packs }));
          this.store.dispatch(new ActionNomenclatureInitialize({ nomenclature: action.payload.auth.nomenclature }));
          if (!action.payload.isEmergencyLogin) {
            this.settingsService.checkEmailAndPhoneStatus(action.payload.auth.settings, false);
          }
        })
      )
  ), { dispatch: false })



  logoutSuccess$ = createEffect(() => {
    return this.actions$
      .pipe(ofType(AuthActionTypes.LOGOUT),
        tap((action: ActionAuthLogout) => {
          this.emergency.clearEmergencyState();
          this.service.destroySession().subscribe();
          this.info.endWait();
          this.router.navigate(['login']).then(() => {
            if (action.isSessionEnded) {
              this.translateService.get('info.sessionEnded').subscribe(value => {
                this.info.error(value);
              });
            }
            this.store.dispatch(new ActionHistoryClearHistory());
            this.store.dispatch(new ActionSettingsClearSettings());
            this.store.dispatch(new ActionCertificatesClearCertificates());
            this.store.dispatch(new ActionDevicesClearDevices());
            this.store.dispatch(new ActionProfilePlanClear());
            this.store.dispatch(new ActionNomenclatureClear());
          });
        })
      );
  }, { dispatch: false })

}
